import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { FeeTypes } from '@app/base/invoices-base';
import { Currency } from '@app/common/settings';
import { HashMap } from 'utils';

@Component({
  selector: 'vshcz-fee-item',
  templateUrl: './fee-item.component.html',
  styleUrls: [ './fee-item.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeeItemComponent {

  feeTypes = FeeTypes;

  @Input()
  id: string;

  @Input()
  number: string;

  @Input()
  totalDue: number;

  @Input()
  currencyId: string;

  @Input()
  type: FeeTypes;

  @Input()
  priceSize = 20;

  @Input()
  symbolSize = 15;

  @Input()
  currencyMap: HashMap<Currency>;
}
